class DocumentNote {
    public NoteId: string;
    public ContactId: string;
    public NoteContent: string;
    public NoteDate: Date;
}

export { DocumentNote };
